<template>
	<main v-editable="blok" class="space-y-section">
		<LazyBreadcrumbs :breadcrumbs="breadcrumbs" class="container" />

		<section class="container !mt-0">
			<div class="flex flex-col gap-4 md:grid md:grid-cols-12 md:gap-0">
				<div class="md:col-span-5 lg:col-span-4">
					<RestaurantGeneralInfo
						v-if="branch"
						:branch="branch"
						:blok="blok"
					/>
				</div>
				<div class="md:col-span-7 md:pl-10 lg:col-span-8">
					<StoryblokComponent
						v-for="item in blok.mapCarousel"
						:key="item._uid"
						:blok="item"
					/>
				</div>
			</div>
		</section>

		<LazyStickyAnchorNav
			:blok="blok"
			:list="findAnchorIn"
			:custom-anchors="customAnchors"
			center-nav
			set-vertical-spacing
		/>

		<section id="dnesni-nabidka" class="container !mt-6 md:!mt-8">
			<div class="bg-neutral-300 sm:rounded-xl min-h-[26.5rem] flex max-sm:flex-col gap-4 lg:gap-10 px-4 py-6 sm:p-6 xl:py-8 xl:px-10">
				<FoodMenuTodayWidget class="grow typo-body-s" :source-branch="branch" show-amount show-allergens>
					<template #header>
						<h2 class="typo-body-m font-bold mb-4">
							Dnešní nabídka ({{ foodMenuFormattedDate }})
						</h2>
					</template>
					<template #footer>
						<AbsoluteInternalLink
							:to="{name: 'branch-sluzby-restaurace-nabidka', params: {branch: branch}}"
							class="btn max-md:btn-secondary md:btn-primary btn-sm mt-4"
						>
							<NuxtIcon name="custom/arrow-right" aria-hidden="true" class="text-xl" filled />
							Menu na celý týden
						</AbsoluteInternalLink>
					</template>
				</FoodMenuTodayWidget>
				<div class="rem:max-w-[343px] sm:min-w-48">
					<RestaurantMenuTile />
				</div>
			</div>
		</section>

		<StoryblokComponent
			v-for="item in blok.body"
			:key="item._uid"
			:blok="item"
		/>

		<StoryblokComponent
			v-if="newsletterBanner"
			:id="newsletterBanner.slug"
			:blok="newsletterBanner.content"
		/>

		<StoryblokComponent
			v-for="item in blok.bodySecond"
			:key="item._uid"
			:blok="item"
		/>

		<section class="container my-8 lg:my-16">
			<Click :placement="AdPosition.RESTAURANT_1" />
		</section>

		<ModalStateInfo
			v-if="blok.stateInfo?.length"
			:state-info="blok.stateInfo[0]"
		/>
	</main>
</template>

<script setup lang="ts">
	import {useRouteParams} from '@vueuse/router';
	import {useNow} from '@vueuse/core';
	import {format} from 'date-fns';
	import {cs} from 'date-fns/locale';
	import useSeoSettings from '~/composables/useSeoSettings';
	import type {PageTypeRestaurantStoryblok} from '@/storyblok/types';
	import {AdPosition} from '~/openapi';

	type Props = {
		blok: PageTypeRestaurantStoryblok;
	};

	const props = defineProps<Props>();
	const newsletterBanner = computed(() => resolvedStory(props.blok.newsletterSignupBanner));

	const branch = useRouteParams<string>('branch');
	const breadcrumbs = inject('breadcrumbs');
	const findAnchorIn = computed(() => ['body']);
	const foodMenuFormattedDate = computed(() => format(useNow().value, 'EEEE d. M. yyyy', {locale: cs}));

	const customAnchors = computed(() => {
		const anchors = [
			{
				anchor: 'dnesni-nabidka',
				label: 'Dnešní nabídka',
			},
		];

		return anchors;
	});

	useSeoSettings(props.blok.seoSettings?.[0]);
</script>
